import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import {
    FlowOfFunds,
    AddConsiderationRowRequest,
} from '../../../../models/FlowOfFunds/flow-of-funds.model';

export interface AddConsiderationRowParams extends AddConsiderationRowRequest {
    engagementId: number;
    section: number;
}

export interface AddConsiderationRowRejection {
    isConflict: boolean;
}

export const AddConsiderationRow = createAsyncThunk(
    'flowOfFunds/addConsiderationRow',
    async (params: AddConsiderationRowParams, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.post(
                `/api/PurchasePriceConsideration/${params.engagementId}/Rows/${params.section}`,
                {
                    values: params.values,
                }
            );

            if (response.status !== 200) {
                throw new Error('Failed to add the row');
            }

            return response.data as FlowOfFunds;
        } catch (error) {
            createNotification('Could not add the row.', 'error');
            return dispatch.rejectWithValue({
                isConflict: false,
            } as AddConsiderationRowRejection);
        }
    }
);
